import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AnalyticsPage } from "@/features/analytics/analytics-page";

const search = z.object({
  days: z.coerce.number().int().optional(),
  metric: z.string().optional(),
});

export const Route = createFileRoute("/_app/analytics")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "Analytics · Malfak" }] }),
  component: AnalyticsPage,
});
